module.exports = __webpack_public_path__ + "img/cost-icon__juegos_infantiles.491bd248.svg";